<template>
  <div class="edit-okr">
    <div class="breadcrumb">
      <a-breadcrumb
        v-show="breadSubTitle"
        separator=">"
      >
        <a-breadcrumb-item>
          <router-link to="/">
            我的目标
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ breadSubTitle }}</a-breadcrumb-item>
      </a-breadcrumb>
      <div class="tipsBox">
        <div class="okr-guaid">
          <a-icon
            type="info-circle"
            style="color: #0064fa;"
            theme="filled"
          /> 遇到问题？立即查看 <a
            class="linkBtn"
            @click="showTips"
          >填写指南</a> ～
        </div>
        <div class="okr-time2">
          {{ updateTime }}
        </div>
      </div>
    </div>
    <div
      v-for="(objectItem, objectIndex) in objectList"
      :key="objectIndex"
      class="edit-okr__item"
    >
      <div class="edit-okr__object">
        <div class="edit-okr__header">
          <span>目标{{ objectIndex + 1 }}</span>
        </div>
        <div class="edit-okr__content">
          <!-- textarea 组件的样式是动态计算的，需要强制覆盖; 用max-length控制最多可输入2000字（不区分中英文） -->
          <a-textarea
            style="min-height: 80px; line-height: 30px;"
            :class="objectItem.noObjectDetail ? 'wrongBox': ''"
            placeholder="输入内容"
            maxlength="1000"
            :autosize="{ minRows: 2 }"
            :value="objectItem.objectDetail"
            @blur="(e) => formateContent(objectItem, 'objectDetail', e.target.value)"
            @change="(e) => handleObjectFieldChange(objectIndex, 'objectDetail', e.target.value)"
            @focus="() => handleAllContentClear(objectItem, 'noObjectDetail', 'objectDetail')"
          />
          <weight
            :value="objectItem.weight"
            :is-object="Boolean('true')"
            :is-error="objectItem.weightError"
            @change="(v) => handleObjectFieldChange(objectIndex, 'weight', v)"
            @myFocus="() => handleClearForC(objectItem,'weightError')"
          />
        </div>
      </div>
      <div
        class="edit-okr__key-result"
      >
        <div class="edit-okr__header">
          <span>关键结果</span>
          <a-button
            class="edit-okr__inner-button"
            type="primary"
            ghost
            @click="() => handleClickAddKeyResult(objectIndex)"
          >
            添加
          </a-button>
        </div>
        <div
          v-for="(krItem, krIndex) in objectItem.keyResultList"
          :key="krIndex"
          class="edit-okr__content"
        >
          <!-- textarea 组件的样式是动态计算的，需要强制覆盖-->
          <a-textarea
            style="min-height: 80px; line-height: 30px;"
            :class="krItem.noKeyResult?'wrongBox':''"
            placeholder="输入内容"
            maxlength="1000"
            :autosize="{ minRows: 2 }"
            :value="krItem.keyResultDetail"
            @blur="(e) => formateContent(krItem, 'keyResultDetail', e.target.value)"
            @change="(e) => handleKeyResultFieldChange(objectIndex, krIndex, 'keyResultDetail', e.target.value)"
            @focus="() => handleAllContentClear(krItem, 'noKeyResult', 'keyResultDetail')"
          />
          <weight
            :value="krItem.weight"
            :is-error="krItem.weightError"
            @change="(v) => handleKeyResultFieldChange(objectIndex, krIndex, 'weight', v)"
            @myFocus="() => handleClearForC(krItem,'weightError')"
          />
          <result-target
            :ten-target="krItem.tenTarget"
            :seven-target="krItem.sevenTarget"
            :is-error="krItem.noSevenTarget"
            @change="(k, v) => handleKeyResultFieldChange(objectIndex, krIndex, k, v)"
            @myFocus="() => handleClearForC(krItem,'noSevenTarget')"
          />
          <a-button
            class="edit-okr__inner-button"
            type="primary"
            ghost
            :disabled="objectItem.keyResultList.length <= 1"
            @click="() => handleClickDeleteKeyResultItem(objectIndex, krIndex)"
          >
            删除
          </a-button>
        </div>
      </div>
    </div>
    <div class="edit-okr__footer">
      <a-button
        type="primary"
        ghost
        @click="handleClickSave"
      >
        存草稿
      </a-button>
      <a-button
        class="edit-okr__submit"
        type="primary"
        ghost
        :loading="isSubmittig"
        @click="handleClickSubmit"
      >
        提交
      </a-button>
    </div>
    <!-- 填写指南弹框 -->
    <a-modal
      v-model="tipsModal"
      title="填写指南"
      centered
      :closable="false"
      :footer="null"
      :mask-closable="false"
      :width="640"
    >
      <p>目标至少填写1个，且保证信息填写完整。具体包括目标及其对应的权重、关键结果（至少填写1个）及其对应的权重、衡量标准（7分为必填项）</p>
      <p>
        · 单个目标的权重不可小于 10% ，各目标权重总和需等于 100% <br>
        <span class="tipsTxt1 padB1">若只有一个目标，则该目标的权重需要等于 100% </span><br>
        · 单个关键结果的权重不可小于 10% ，同一目标下的关键结果权重总和需等于 100% <br>
        <span class="tipsTxt1">若1个目标下，只有1个关键结果，则该关键结果的权重需要等于100%</span><br>
      </p>
      <h3>Q &amp; A 常见问题</h3>
      <dl class="tipsMBox">
        <dt><span>Q</span>必须填写3个目标吗？</dt>
        <dd>
          <span>A</span>
          为保证聚焦重要目标并拿到结果，目标不可少于1个，最多为3个。BP建议：3个目标且每个目标下3个关键结果。
        </dd>
        <dt><span>Q</span>关键结果的7分和10分衡量标准一定要填写吗？如何填写？</dt>
        <dd>
          <span>A</span>
          根据自身实际情况填写，一般都有7分和10分衡量标准，每个关键结果所对应的7分衡量标准为必填项，指令性工作可不填写10分衡量标准；建议从多（数量）快（时间）好（质量）省（成本）来区分7分和10分，同时7分衡量标准为80%能达成，10分衡量标准为50%能达成。
        </dd>
        <dt><span>Q</span>业绩目标提交后可以修改吗？</dt>
        <dd>
          <span>A</span>
          当前季度的目标是可以修改的，与直接上级进行沟通对齐后，方能进行修改。
        </dd>
      </dl>
      <div style="text-align:center;">
        <a-button
          class="edit-okr__submit"
          type="primary"
          @click="hideTips"
        >
          好的，我知道了
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Button, Modal, message, Breadcrumb, Notification, Icon } from 'ant-design-vue'

import Weight from '@components/weight/index.vue'
import ResultTarget from './result-target'

Vue.use(Input)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(Button)
Vue.use(Breadcrumb)

export default {
  name: 'EditOKR',
  components: {
    Weight,
    ResultTarget,
  },
  props: {},
  data() {
    return {
      objectList: [],
      tmpList: [],
      id: null,
      isSubmittig: false,
      value: '',
      year: '',
      quarter: '',
      breadSubTitle: '',
      updateTime: '',
      haveChange: false,
      tipsModal: false,
    }
  },
  computed: {
    userId: {
      get () {
        return this.$store.state.userId
      },
    },
  },
  watch: {
    userId() {
      this.fetchEditData()
    },
    haveChange(r) {
      // 默认将离开页面的浏览器事件置空
      window.onbeforeunload = null
      if (r) {
        window.onbeforeunload = function(e) {
          e = window.event || e
          e.returnValue = ('您的数据尚未保存，确定离开当前页面吗？')
        }
      }
    },
  },
  created() {
    this.$store.dispatch('getServerTime')
    this.id = this.$route.params.okrId
    this.year = this.$route.params.year
    this.quarter = this.$route.params.quarter
    this.breadSubTitle = `${this.year}年Q${this.quarter}季度业绩目标`

    // 若userId不为空，则不用等监听，直接执行函数 （从详情点编辑当前页面跳转时会停留在空白页面的bug）
    if (this.userId) {
      this.fetchEditData()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.haveChange) {
      Modal.confirm({
        title: '是否保存此次编辑内容？',
        content: '保存后下次可继续编辑。',
        icon: 'exclamation-circle',
        okText: '保存',
        cancelText: '不保存',
        onOk: () => {
          this.handleClickSave()
          next()
        },
        onCancel: () => {
          next()
          // 若不保存，将离开页面的浏览器事件置空，以免影响列表页操作
          window.onbeforeunload = null
        },
      })
    } else {
      next()
    }
  },
  beforeDestory () {
    // 页面销毁前，将事件置空
    window.onbeforeunload = null
  },
  methods: {
    // 获取编辑页数据
    async fetchEditData() {
      const { genNewOKRData, genNewKeyResultData } = this
      const hide = message.loading('正在加载...')
      try {
      // 进入编辑，都要发送请求从接口拿
        const result = await this.$api.okr.getTemp({ year: this.year, quarter: this.quarter })

        // eslint-disable-next-line
        console.log('result', result)
        if (!result) {
          // 如果不存在 result，判定为是新建
          this.$set(this, 'objectList', [
          // 固定三个 O
            genNewOKRData(),
            genNewOKRData(),
            genNewOKRData(),
          ])
          this.haveChange = true
        } else {
        // 判断该okr对应用户是否是登录用户，如果不匹配，跳转到该okr详情页（修复从地址栏修改参数从而编辑任何人okr的漏洞）
          if (result.userId !== this.userId) {
            this.$router.replace({
              name: 'OKRDetail',
              params: this.id,
            })
          } else {
            this.updateTime = `最近一次保存时间 ${result.keepTime}`
            this.objectList = result.objectList.map(objectItem => {
              const keyResultList = objectItem.keyResultList
              // 如果没有 KR，则先给他一个默认值
              if (!keyResultList || !keyResultList.length) {
                objectItem.keyResultList = [
                  genNewKeyResultData(),
                ]
              }

              return objectItem
            })
          }
        }
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        hide()
      }
    },
    /**
     * 生成新的单条 OKR 数据
     * @return {Object} 返回新的 OKR 数据
     */
    genNewOKRData() {
      return {
        // object 详情
        objectDetail: '',
        // 权重
        weight: 0,
        keyResultList: [
          this.genNewKeyResultData(),
        ],
      }
    },
    /**
     * 生成新的关键结果数据
     * @return {Object} 返回新的 KR 数据
     */
    genNewKeyResultData() {
      return {
        // 关键结果详情
        keyResultDetail: '',
        // 七分目标
        sevenTarget: '',
        // 十分目标
        tenTarget: '',
        // 权重
        weight: 0,
      }
    },
    /**
     * 点击添加 KR，往 O 里 push 一个 KR
     * @param {Number} objectIndex O 的索引
     */
    handleClickAddKeyResult(objectIndex) {
      this.objectList[objectIndex].keyResultList.push(this.genNewKeyResultData())
      this.haveChange = true
    },
    /**
     * Object 字段改变，加入数组
     * @param {Number} objectIndex O 的索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleObjectFieldChange(objectIndex, k, v) {
      this.$set(this.objectList[objectIndex], k, v)
      this.haveChange = true
    },
    /**
     * KeyResult 字段改变，加入数组
     * @param {Number} objectIndex O 的索引
     * @param {Number} krIndex KR 的索引
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleKeyResultFieldChange(objectIndex, krIndex, k, v) {
      this.$set(this.objectList[objectIndex].keyResultList[krIndex], k, v)
      this.haveChange = true
    },
    /**
     * 格式化文案
     * @param {String} item 数据源/对象
     * @param {String} k 字段名
     * @param {String} v 值
     */
    formateContent(item, k, v) {
      v = v.replace(/[ ]+/g, ' ')
      this.$set(item, k, v)
      this.haveChange = true
    },
    /**
     * 清除报错样式与文案
     * @param {String} item 数据源/对象
     * @param {String} name 字段名
     * @param {String} othername 字段名
     * @param {String} v 值
     */
    handleAllContentClear(item, name, othername) {
      if (item[name]) {
        this.$set(item, name, false)
        this.$set(item, othername, '')
      }
    },
    /**
     * 清除自定义组件报错样式与文案
     * @param {String} item 数据源/对象
     * @param {String} name 字段名
     */
    handleClearForC(item, name) {
      if (item[name]) {
        this.$set(item, name, false)
        // 强制视图重新渲染，解决权重报错状态更新不及时的bug，可能会导致性能损耗
        this.$forceUpdate()
      }
    },
    /**
     * 点击删除 KR 条目事件
     * @param {Number} objectIndex O 的索引
     * @param {Number} krIndex KR 的索引
     */
    handleClickDeleteKeyResultItem(objectIndex, krIndex) {
      const krLengthInCurrentObject = this.objectList[objectIndex].keyResultList.length

      if (krLengthInCurrentObject <= 1) {
        return
      }

      Modal.confirm({
        title: '确定要删除吗？',
        content: '删除内容后将无法恢复哦~',
        icon: 'exclamation-circle',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.objectList[objectIndex].keyResultList.splice(krIndex, 1)
          this.haveChange = true
        },
      })
    },
    /**
     * 点击保存按钮
     */
    async handleClickSave() {
      this.spliArray()
      const { tmpList, id, year, quarter } = this
      try {
        const data = {
          year,
          quarter,
          objectList: tmpList,
        }
        if (id) {
          data.id = id
        }
        // eslint-disable-next-line
        console.log('tmpList-preserve', tmpList)
        await this.$api.okr.preserve(data)
        Notification.open({
          type: 'success',
          message: '已保存',
          description:
            '已为您保存成功啦~',
          style: 'background-color:#E4FDDA',
        })
        this.haveChange = false
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    /**
     * 点击提交按钮
     */
    async handleClickSubmit() {
      const { objectList, isStringFieldValid, id, year, quarter } = this
      try {
        // 清除报错状态
        objectList.forEach(oItem => {
          if (oItem.noObjectDetail) {
            oItem.noObjectDetail = false
            oItem.objectDetail = ''
          }
          if (oItem.weightError) {
            oItem.weightError = false
          }
          const { keyResultList } = oItem
          keyResultList.forEach(krItem => {
            if (krItem.noKeyResult) {
              krItem.noKeyResult = false
              krItem.keyResultDetail = ''
            }
            if (krItem.noSevenTarget) {
              krItem.noSevenTarget = false
              krItem.sevenTarget = ''
            }
            if (krItem.weightError) {
              krItem.weightError = false
            }
          })
        })

        let isNotBlank = false
        // 校验字段是否全部为空（十分内容不进行校验）
        objectList.some(objectItem => {
          if (isStringFieldValid(objectItem.objectDetail) || objectItem.weight !== 0) {
            isNotBlank = true
            return isNotBlank
          }
          const { keyResultList } = objectItem
          // 遍历 KR 里的字符串字段
          keyResultList.some(krItem => {
            if (
              isStringFieldValid(krItem.keyResultDetail)
              // || isStringFieldValid(krItem.tenTarget)
              || isStringFieldValid(krItem.sevenTarget)
              || krItem.weight !== 0
            ) {
              isNotBlank = true
              return isNotBlank
            }
            return isNotBlank
          })
          return isNotBlank
        })

        // 如果全部为空则提示不能提交空表单
        if (!isNotBlank) {
          Modal.warning({
            title: '请勿提交空表单',
            content: '请填写内容后，再次点击“提交”按钮。',
            okType: 'danger',
            okText: '好的',
          })
          return
        } else { // 如果有内容则进入内容校验
          // 收集有内容的o与kr的索引，全部没有内容则不进行校验
          let haveKr = false // 判断kr是否有内容的变量
          const indexArr = []
          let krArr = [] // 收集kr有内容的kr索引的临时数组

          objectList.forEach((oItem, indexA) => {
            const { keyResultList } = oItem
            keyResultList.forEach((krItem, indexB) => {
              if (
                isStringFieldValid(krItem.keyResultDetail)
              || isStringFieldValid(krItem.sevenTarget)
              || krItem.weight !== 0
              ) {
                krArr.push({ krIndex: indexB })
                haveKr = true
              }
            })
            if (haveKr) {
              indexArr.push({ oIndex: indexA, krs: krArr })
              haveKr = false
              krArr = []
            } else {
              if (isStringFieldValid(oItem.objectDetail) || oItem.weight !== 0) {
                indexArr.push({ oIndex: indexA })
              }
            }
          })
          // eslint-disable-next-line
          console.log('有内容o的序号', indexArr)

          // 校验规则：indexArr数组中全部都要走为空校验，权重最小不能少于10，权重和必须是100%
          let haveError = false
          let sumOW = 0 // 计算O的权重和的变量
          let owHaveError = false // 判断O的权重是否有报错，排除权重和为100时其他o的权重有报错的情况
          indexArr.forEach(i => {
            if (!objectList[i.oIndex].objectDetail) {
              objectList[i.oIndex].noObjectDetail = true
              objectList[i.oIndex].objectDetail = '请填写目标'
              haveError = true
            }
            if (!objectList[i.oIndex].weight || objectList[i.oIndex].weight < 10) {
              objectList[i.oIndex].weightError = true
              haveError = true
              owHaveError = true
            } else {
              sumOW = sumOW + objectList[i.oIndex].weight
            }
            if (!i.krs) { // o下面kr为空时，全部报错变红
              objectList[i.oIndex].keyResultList.forEach(krItem => {
                krItem.noKeyResult = true
                krItem.keyResultDetail = '请填写关键结果'
                krItem.noSevenTarget = true
                krItem.sevenTarget = '请填写衡量标准'
                krItem.weightError = true
                haveError = true
              })
            } else { // o下面kr有内容时进行为空校验以及kr权重和的校验
              let sumKW = 0// 计算kr的权重和的变量
              let kwHaveError = false // 判断kr的权重是否有报错，排除权重和为100时其他kr的权重有报错的情况
              i.krs.forEach(k => {
                const krItem = objectList[i.oIndex].keyResultList[k.krIndex]
                if (!krItem.keyResultDetail) {
                  krItem.noKeyResult = true
                  krItem.keyResultDetail = '请填写关键结果'
                  haveError = true
                }
                if (!krItem.sevenTarget) {
                  krItem.noSevenTarget = true
                  krItem.sevenTarget = '请填写衡量标准'
                  haveError = true
                }
                if (!krItem.weight || krItem.weight < 10) {
                  krItem.weightError = true
                  haveError = true
                  kwHaveError = true
                } else {
                  sumKW = sumKW + krItem.weight
                }
              })
              // eslint-disable-next-line
              console.log('sumKW', sumKW)
              if (sumKW !== 100 || (kwHaveError && sumKW === 100)) {
                i.krs.forEach(k => {
                  const krItem = objectList[i.oIndex].keyResultList[k.krIndex]
                  krItem.weightError = true
                  haveError = true
                })
              }
            }
          })
          // eslint-disable-next-line
            console.log('sumOW', sumOW)
          if (sumOW !== 100 || (owHaveError && sumOW === 100)) {
            indexArr.forEach(i => {
              objectList[i.oIndex].weightError = true
              haveError = true
            })
          }

          // eslint-disable-next-line
          console.log('haveError', haveError)
          if (haveError) {
            // 强制视图重新渲染，解决权重报错状态更新不及时的bug，可能会导致性能损耗
            this.$forceUpdate()
            Notification.open({
              type: 'error',
              message: '未正确填写表单内容',
              description:
                '如需帮助请查看左上角《填写指南》。',
              style: 'background-color:#FFECE4',
            })
          } else {
            this.spliArray()
            this.isSubmittig = true
            const action = id ? 'submit' : 'create'

            const data = {
              year,
              quarter,
              objectList: this.tmpList,
            }
            if (id) {
              data.id = id
            }
            // eslint-disable-next-line
            console.log('tmpList-submit', this.tmpList)
            // eslint-disable-next-line
            console.log('objectList-submit', objectList)
            const result = await this.$api.okr[action](data)

            message.success('提交成功')
            this.haveChange = false

            setTimeout(() => {
            // 如果有 ID 跳详情，没 ID 跳列表页
              this.$router.replace({
                name: 'OKRDetail',
                params: {
                  okrId: id || result,
                },
              })
            }, 500)
          }
        }
        // eslint-disable-next-line
        console.log('2objectList', objectList)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        this.isSubmittig = false
      }
    },
    /**
     * 字符串字段值是否有效
     * @param {String} v value
     * @return {Boolean} 是否有效
     */
    isStringFieldValid(v) {
      return v && v.trim().length > 0
    },
    /* 将数据列表清理好进行提交 */
    spliArray() {
      const tmpData = []
      let tmpKrs = []
      this.objectList.forEach(oItem => {
        oItem.keyResultList.forEach(krItem => {
          const tmpKr = {
            keyResultDetail: krItem.noKeyResult ? '' : krItem.keyResultDetail,
            sevenTarget: krItem.noSevenTarget ? '' : krItem.sevenTarget,
            tenTarget: krItem.tenTarget,
            weight: krItem.weight,
          }
          if (krItem.id) { tmpKr.id = krItem.id }
          tmpKrs.push(tmpKr)
        })
        const tmpO = {
          objectDetail: oItem.noObjectDetail ? '' : oItem.objectDetail,
          weight: oItem.weight,
          keyResultList: tmpKrs,
        }
        if (oItem.id) { tmpO.id = oItem.id }
        tmpData.push(tmpO)
        tmpKrs = []
      })
      this.$set(this, 'tmpList', tmpData)
      // eslint-disable-next-line
        console.log('spliArr', this.tmpList)
    },
    /* 显示隐藏编辑指南弹框 */
    showTips() {
      this.tipsModal = true
    },
    hideTips() {
      this.tipsModal = false
    },
  },
}

</script>

<style lang="less">
@import '~@assets/style/variables.less';

.edit-okr {position: relative; padding-bottom:102px;
  &__item {
    display: flex;
    padding: 16px;
    margin-bottom: 16px;
    background: #E8EAED;
  }

  &__object,
  &__key-result {
    flex-grow: 1;

    &:not(:last-child) {
      margin-right: 4px;
    }
  }

  &__object {
    min-width: 30%;
  }

  &__header,
  &__content {
    display: flex;
    background: @white;
    border-radius: 4px;
  }

  &__header {
    justify-content: space-between;
    align-items: center;

    padding: 0 15px;
    height: 40px;

    font-weight: 600;

    & > :first-child {
      display: flex;
      align-items: center;

      &::before {
        content: '';

        display: inline-block;
        margin-right: 8px;

        width: 4px;
        height: 12px;
        background: @blue;
        border-radius: 2px;
      }
    }
  }

  &__content {
    padding: 15px;
    margin-top: 4px;

    > :not(:last-child) {
      margin-right: 8px;
    }
  }

  &__inner-button {
    padding: 0 14px;
    height: 20px;
    line-height: 1;
    font-size: @normal;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    padding: 0 170px;

    background: @white;

    > button {
      padding: 0 30px;
      margin-left: 12px;
    }
  }

  &__submit {
    background: #005EFE;

    &:hover,
    &:active,
    &:focus {
      background: @blue;
    }
  }
}
.breadcrumb{
margin-bottom: 40px;
padding-bottom:16px;
border-bottom: 1px solid #DDD;
}
.tipsBox{
position:absolute;
left:0;
right: 0;
top:38px;
display:flex;
justify-content: space-between;
height: 40px;
line-height: 40px;
font-size:13px;
.okr-time2{color:#ccc;}
.okr-guaid{padding-left: 16px; color:#444;
.tipsLink{color:#0064fa;}
.tipsLink:hover{color:#0078fa; cursor: pointer;}
}
}
.tipsTxt1{color:#777; padding-left: 24px;}
.padB1{display:inline-block; padding-bottom: 8px;}
.tipsMBox{margin:12px 0 24px; border-radius: 5px; background-color: #f8f8f8; padding: 16px 14px 14px 16px;
dt,dd{position: relative; padding-left: 18px;}
dt{font-weight: 500; }
dd+dt{margin-top: 16px;}
dd{
span{color:#0064fa;}}
span{position: absolute; left:0; top:-1px; font-size: 16px; font-weight: 500;}
}
.linkBtn{color:#0064fa;}
.linkBtn:hover{color:#0078fa;}
.wrongBox{border-color:#FF3000; color:#FF3000;}
</style>
